import { render } from "./MessageCompose.vue?vue&type=template&id=e95f1af0&scoped=true&ts=true"
import script from "./MessageCompose.vue?vue&type=script&lang=ts"
export * from "./MessageCompose.vue?vue&type=script&lang=ts"

import "./MessageCompose.vue?vue&type=style&index=0&id=e95f1af0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95f1af0"]])

export default __exports__